import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { getConfig } from '@cian/config/browser';
import { getLogger } from '@cian/logger/browser';
import { getHttpApi } from '@cian/http-api/browser';
import * as smoothScroll from 'smoothscroll-polyfill';
import { TReduxStore } from '../../../shared/types/redux';
import { Application } from '../../../shared/containers/App';
import { ICustomContextParams } from '../../../shared/types/ICustomContextParams';

interface IDependencies {
  store: TReduxStore;
}

export function renderApplication(dependencies: IDependencies) {
  const { store } = dependencies;
  const config = getConfig();
  const httpApi = getHttpApi();
  const logger = getLogger();

  const projectName = config.getStrict<string>('projectName');
  const customContext = config.getStrict<ICustomContextParams>('applicationContext.custom');
  const rootElement = document.getElementById(projectName as string);
  smoothScroll.polyfill();

  if (!rootElement) {
    throw new Error(`Unable to find element #${projectName}`);
  }

  ReactDOM.hydrateRoot(
    rootElement,
    <Application config={config} logger={logger} httpApi={httpApi} reduxStore={store} customContext={customContext} />,
  );
}
